import { jsx } from "react/jsx-runtime";
import { Shape } from "./Shape.mjs";
const Header = ({}) => /* @__PURE__ */ jsx(Shape, { height: "32px" });
export {
  Header
};
